export const SMALL_DEVICES = '(max-width: 767px)';
